import { FC } from "react";
import { Table } from "@tanstack/react-table";
import { scheduledJobsTableColumns } from "./scheduledJobsTableColumns";
import { SchedulesToolbar } from "../../../common/list/SchedulesToolbar";
import { Schedule2 } from "../../../../../../services/cloudchipr.api";
import { DataGrid } from "../../../../../../storybook/data-grid/DataGrid";
import { DataGridProvider } from "../../../../../../storybook/data-grid/DataGridProvider";
import { useSchedulesColumnsSortingHook } from "../../../common/utils/hooks/useSchedulesColumnsSorting.hook";

interface ScheduledJobsListGridProps {
  schedules: Schedule2[];
}

export const ScheduledJobsDataGrid: FC<ScheduledJobsListGridProps> = ({
  schedules,
}) => {
  const { sorting, setSorting } = useSchedulesColumnsSortingHook("schedule");

  return (
    <DataGridProvider>
      <DataGrid
        globalFilter
        columnResizeMode="onEnd"
        enableStickyColumns={!!schedules?.length}
        columnSorting={{
          initialSort: sorting,
          onColumnsSortingChange: setSorting,
        }}
        columnVisibility
        styles={styles}
        data={schedules}
        columns={scheduledJobsTableColumns}
        toolbar={dataGridToolbar}
      />
    </DataGridProvider>
  );
};

const dataGridToolbar = {
  renderToolbar: ({
    table,
    globalFilter,
    setGlobalFilter,
  }: {
    table: Table<any>;
    globalFilter: string | number;
    setGlobalFilter: (value: string) => void;
  }) => {
    return (
      <SchedulesToolbar
        table={table}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
    );
  },
};

const styles = {
  table: {
    tableLayout: "fixed",
  },
  tableHeaderRow: {
    "& th": {
      borderTop: 1,
      borderColor: "grey.300",
      py: 0.75,
      bgcolor: "white",
    },
    "& th:first-of-type": {
      pl: 3,
    },
  },
};
